import jwtDecode from 'jwt-decode';

import environmentVariables from '../appVariables';

import { ILoginUserSuccessResponse } from '../views/Auth/Login/interfaces/IGoogleUser';

export const decryptToken = (token: string): string => {
  const reverseSwapMap = environmentVariables?.jwtCharactersSwap
    ?.split(',')
    .reduce((acc: { [key: string]: string }, pair) => {
      const [key, value] = pair.split(':');

      return { ...acc, [value]: key };
    }, {});

  return token
    .split('')
    .map((char) => reverseSwapMap?.[char] ?? char)
    .join('');
};

export const tokenDecode = (token: string): ILoginUserSuccessResponse => {
  try {
    const decryptedToken = decryptToken(token);

    return jwtDecode(decryptedToken);
  } catch (error) {
    throw new Error(`Failed to import JWK. Ensure the key is valid and properly formatted. ${error}`);
  }
};
